import script from "./newsCard2.vue?vue&type=script&setup=true&lang=js"
export * from "./newsCard2.vue?vue&type=script&setup=true&lang=js"

import "./newsCard2.vue?vue&type=style&index=0&id=cbed4af8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbed4af8"]])

export default __exports__